export const iconFontAwesomeHumanitarianPersonDigging = (
	<i className="fa-solid fa-person-digging"></i>
);
